// export const ACTIVITY_PLUGIN_ID = '3180f6e0-581e-11ea-a092-c33a1779404d';
export const TEMPLATE_SELECTED_EVENT_NAME = 'templateSelected';
export const ETEXT_COURSE_PLUGIN_ID = '2a5058f0-6d88-11ea-b2ed-8d9c059418aa';
export const ETEXT_CHAPTER_PLUGIN_ID = '8d716cc0-6d7a-11ea-9e95-516eb2d4a399';
export const STITCHED_LESSON_PLUGIN_ID = 'afe0b8a0-7f9b-11ea-af65-af7754595c61';
export const CORNUCOPIA_SCREEN_PLUGIN_ID = '2a150101-e604-11ec-9344-a7f4dfb24b7b';

export const pathwayType = 'FREE';
export const keyPath = ['pathway'];
export const pluginVersion = '*';

export const coursePreload = 'NONE';
export const chapterPreload = 'FIRST';
export const lessonPreload = 'ALL';

export const etextCoursePathwayKeyPath = {
  cover: ['cover'],
  pages: ['pages'],
  chapters: ['chapters'],
};
export const chapterPathwayKeyPath = ['lessons'];
export const lessonPathwayKeypath = ['pathway'];

export const courseConfig = { title: 'Cornucopia eText Course', description: '' };
export const chapterConfig = { title: "Cornucopia Chapter 1", description: "" };
export const lessonConfig = { title: "Cornucopia Lesson 1", description: "" };
export const screenConfig = { title: 'Cornucopia Screen', description: "" };
